export default {"src":"/_next/static/media/mondial-logo-black-rgb.718754a6.svg","height":575,"width":550,"blurWidth":0,"blurHeight":0};